import React from 'react';
import { Modal } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { white } from '../../../app/theme';

interface Props {
  isOpen: boolean;
  handleModalOpen: (isOpen: boolean) => void;
}

const useStyles = makeStyles((theme: Theme) => ({
  modalContainer: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontStyle: 'italic',
    color: theme.palette.secondary.main,
  },
  modal: {
    maxWidth: '50%',
    padding: '2em',
    position: 'relative',
    boxSizing: 'border-box',
    backgroundColor: white,
    borderRadius: 5,
    '& a': {
      color: 'inherit',
    },
  },
  closeButton: {
    position: 'absolute',
    top: '0.5em',
    right: '0.5em',
  },
}));

const RequestAccessModal = ({ isOpen, handleModalOpen }: Props): JSX.Element => {
  const classes = useStyles();

  return (
    <Modal open={isOpen} onClose={() => handleModalOpen(false)}>
      <div className={classes.modalContainer}>
        <div className={classes.modal}>
          <IconButton aria-label="close" className={classes.closeButton} onClick={() => handleModalOpen(false)}>
            <CloseIcon />
          </IconButton>
          <p>
            Please email&nbsp;
            <a href="mailto:training@blueearthdxmedicalaffairshub.com?subject=Request Access">
              <strong>training@blueearthdxmedicalaffairshub.com</strong>
            </a>
            , with &quot;Request Access&quot; in the subject line, to request access to Blue Earth Diagnostics Training.
          </p>
          <p>Once your request has been reviewed and approved, you will receive an email detailing next steps.</p>
        </div>
      </div>
    </Modal>
  );
};

export default RequestAccessModal;
